import { IdsInput } from '../../lib/types/utils'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function sendTravelChoiceReminderToStaffs(input: IdsInput) {
  return restApiClient
    .url(constructApiUrl(API.affectedStaffs.sendTravelChoiceReminderToStaffs.url, null))
    .post<never, IdsInput>(input)
}
